import React from 'react'
import {
    MapContainer,
    TileLayer,
    useMap,
    Marker,
    Popup,
    Polyline,
    Polygon,
    Rectangle,
    GeoJSON,
    useMapEvent,
  } from "react-leaflet";
  
function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  }
  
export default ChangeView
